angular.module('am4').factory('rgba', function() {
    return function rgba(input, opacity) {
        var hex = input.replace('#',''),
            r = parseInt(hex.substring(0,2), 16),
            g = parseInt(hex.substring(2,4), 16),
            b = parseInt(hex.substring(4,6), 16);

        return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
    };
});



// WEBPACK FOOTER //
// ./src/app/services/rgba.js